import type { Workspace } from "@omnabase/shared";
import { DEFAULT_ACCENT, DEFAULT_WORKSPACE, applyAccent, storedAccent } from "./accent";
import { applyTheme, effectiveTheme, rememberWorkspaceTheme, storedTheme, storedWorkspaceTheme, type PersonalTheme, type ThemePref } from "./theme";

/** The workspace's look on the page: its accent and colour scheme from the API (Settings › General), the person's own scheme
 *  from this browser (Settings › Profile). Called whenever the workspace loads or its settings change; both are remembered per
 *  workspace so the next visit paints right from the start. */
export function applyLook(w: Pick<Workspace, "slug" | "settings">, personal: PersonalTheme = storedTheme()) {
  applyAccent(w.settings.accent ?? DEFAULT_ACCENT, document.documentElement, localStorage, w.slug);
  rememberWorkspaceTheme(w.settings.colorScheme as ThemePref, localStorage, w.slug);
  applyTheme(effectiveTheme(personal, w.settings.colorScheme as ThemePref));
}

/** Before the first paint: what this browser remembers of the workspace in the URL and of the person, so a dark page never
 *  flashes white and the sign-in page follows the person's choice too. Ported from the prototype's main.tsx. */
export function applyRememberedLook(slug: string = window.location.pathname.split("/")[1] || DEFAULT_WORKSPACE) {
  applyAccent(storedAccent(localStorage, slug), document.documentElement, undefined, slug);
  applyTheme(effectiveTheme(storedTheme(), storedWorkspaceTheme(localStorage, slug)));
}
